import { Divider, Skeleton } from "antd"
import InfiniteScroll from "react-infinite-scroll-component"

import type { Notification } from "../types/notification.types.ts"
import { NotificationsListCard } from "./NotificationsListCard.tsx"

interface NotificationsListProps {
  notifications: Notification[]
  onMarkAsRead: (id: number) => void
  onCardClick: (notification: Notification) => void
  showDelete?: boolean
  handleDelete: (notificationId: number | null) => void
  hasMore: boolean
  onLoadMore: () => void
  height: string | number
}

export function NotificationsList({
  notifications,
  onMarkAsRead,
  onCardClick,
  showDelete,
  handleDelete,
  hasMore,
  onLoadMore,
  height
}: NotificationsListProps) {
  return (
    <InfiniteScroll
      dataLength={notifications?.length}
      loader={<Skeleton paragraph={{ rows: 1 }} active />}
      next={onLoadMore}
      hasMore={hasMore}
      className="tailwind-scroll flex flex-col gap-1 max-h-500"
      endMessage={<Divider />}
      height={height}
    >
      {notifications?.map((notification) => (
        <NotificationsListCard
          key={notification?.id}
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onCardClick={onCardClick}
          showDelete={showDelete}
          handleDelete={handleDelete}
        />
      ))}
    </InfiniteScroll>
  )
}
